import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.checkbox-display': {
    alignItems: 'center',
    '&--disabled': {
      color: COLORS.NEUTRAL400,
    },
  },
  '.checkbox-display': {
    '&__check': {
      color: COLORS.PRIMARY300,
      marginRight: theme.space[2],
    },
    '&__check--disabled': {
      height: '17.5px',
      width: '17.5px',
      border: `1.5px solid ${COLORS.NEUTRAL400}`,
      borderRadius: '3px',
      backgroundColor: COLORS.NEUTRAL100,
      marginRight: theme.space[2],
      display: 'inline-block',
    },
  },
});
